class CountDownTimer{
    consturctor(myDays, myHours, myMinutes, mySeconds) {
        this.countDownDate = new Date("Nov 28, 2025 00:00:00").getTime();
        this.interval = setInterval(() => {
            this.countDownInterval();
        }, 1000);
        
        this.day = myDays;
        this.hr = myHours;
        this.min = myMinutes;
        this.sec = mySeconds;
    }


    countDownInterval() {
        var now = new Date().getTime();

        var distance = this.countDownDate - now;

        this.day.days = Math.floor(distance / (1000 * 60 * 60 * 24));
        this.hr.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        this.min.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        this.sec.seconds = Math.floor((distance % (1000 * 60)) / 1000);

        document.getElementById("days").innerHTML = this.day._days;
        document.getElementById("hours").innerHTML = this.hr._hours;
        document.getElementById("minutes").innerHTML = this.min._minutes;
        document.getElementById("seconds").innerHTML = this.sec._seconds;

        if (distance < 0) {
            clearInterval(interval);
            document.getElementById("countdown-timer-container").innerHTML = "EXPIRED";
        }
    }
}

const myDays = {
    _days: 0,
    get days() {
        return this._days;
    },
    set days(newDays) {
        if(newDays !== this._days) {
            document.getElementById("days").style.animationPlayState = 'running';
            this._days = newDays;
        }
        else {
            document.getElementById("days").style.animationPlayState = 'paused';
        }
    }
}

const myHours = {
    _hours: 0,
    get hours() {
        return this._hours;
    },
    set hours(newHour) {
        if(newHour !== this._hours) {
            document.getElementById("hours").style.animationPlayState = 'running';
            this._hours = newHour;
        }
        else {
            document.getElementById("hours").style.animationPlayState = 'paused';
        }
    }
}

const myMinutes = {
    _minutes: 0,
    get minutes() {
        return this._minutes;
    },
    set minutes(newMinute) {
        if(newMinute !== this._minutes) {
            document.getElementById("minutes").style.animationPlayState = 'running';
            this._minutes = newMinute;
        }
        else {
            document.getElementById("minutes").style.animationPlayState = 'paused';
        }
    }
}

const mySeconds = {
    _seconds: 0,
    get seconds() {
        return this._seconds;
    },
    set seconds(newSeconds) {
        if(newSeconds !== this._seconds) {
            document.getElementById("seconds").style.animationPlayState = 'running';
            this._seconds = newSeconds;
        }
        else {
            document.getElementById("seconds").style.animationPlayState = 'paused';
        }
    }
}

const countDownTimer = new CountDownTimer(myDays, myHours, myMinutes, mySeconds);
countDownTimer.consturctor(myDays, myHours, myMinutes, mySeconds);
